<template>
  <!-- BSL §8.1 + BSL-SAT S6: formdan çıkmadan yeni müşteri — İsim, Cep Telefon, E-Posta (zorunlu,
       BSL-MUS M3), Şube. SetMusteri ile açar; 999 pencerede görünür, pencere kapanmaz.
       Kaydedince `kaydedildi(Musteri_rowid)`; açan form müşteriyi seçili getirir. -->
  <Dialog :visible="visible" @update:visible="kapat" modal header="Yeni müşteri"
    :breakpoints="{ '640px': '100vw' }" class="w-full sm:max-w-md">
    <div class="flex flex-col gap-3">
      <Message v-if="uyari" severity="warn" :closable="false">{{ uyari }}</Message>
      <FormAlan etiket="İsim" zorunlu hedef-id="HizliIsim" :hata="Hata.Isim">
        <InputText id="HizliIsim" v-model="Isim" class="w-full text-base" :invalid="!!Hata.Isim" autofocus />
      </FormAlan>
      <FormAlan etiket="Cep Telefon" zorunlu hedef-id="HizliTelefon" :hata="Hata.CepTelefon">
        <TelefonGirisi id="HizliTelefon" v-model="CepTelefon" :invalid="!!Hata.CepTelefon" />
      </FormAlan>
      <FormAlan etiket="E-Posta" zorunlu hedef-id="HizliEPosta" :hata="Hata.EPosta">
        <InputText id="HizliEPosta" v-model="EPosta" type="email" class="w-full text-base" :invalid="!!Hata.EPosta" />
      </FormAlan>
      <FormAlan v-if="subeler.length > 1" etiket="Şube" zorunlu hedef-id="HizliSube" :hata="Hata.pSube">
        <Select id="HizliSube" v-model="pSube" :options="subeler" option-label="Ad" option-value="Sube_rowid"
          placeholder="Seçin" class="w-full text-base" :invalid="!!Hata.pSube" />
      </FormAlan>
    </div>
    <template #footer>
      <Button label="Vazgeç" severity="secondary" text @click="kapat(false)" />
      <Button label="Kaydet ve seç" icon="pi pi-check" :loading="kaydediliyor" @click="kaydet" />
    </template>
  </Dialog>
</template>

<script>
export default {
  name: "HizliMusteri",
  props: {
    visible: { type: Boolean, default: false },
    varsayilanSube: { type: [Number, String], default: null }, // açan formun şubesi seçili gelir
    varsayilanIsim: { type: String, default: "" },             // aramada yazılan metin
    varsayilanSubeGuid: { type: String, default: "" },         // BSL-RDV: formu GUID ile bilen açanlar
  },
  emits: ["update:visible", "kaydedildi"],
  data() {
    return {
      Isim: "", CepTelefon: "", EPosta: "", pSube: null,
      subeler: [], uyari: "", kaydediliyor: false,
      Hata: { Isim: "", CepTelefon: "", EPosta: "", pSube: "" },
    };
  },
  watch: {
    visible(v) {
      if (!v) return;
      this.Isim = this.varsayilanIsim || "";
      this.CepTelefon = "";
      this.EPosta = "";
      this.uyari = "";
      Object.keys(this.Hata).forEach((k) => { this.Hata[k] = ""; });
      this.pSube = Number(this.varsayilanSube) || this.guidSube() || null;
      if (!this.subeler.length) this.subeleriYukle();
    },
  },
  methods: {
    subeleriYukle() {
      this.$Servis("GET", "GetSubeTablosu_Aktif_KullaniciYetkili", "")
        .then((res) => {
          if (res.status === 200 && Array.isArray(res.data)) {
            this.subeler = res.data;
            if (this.subeler.length === 1) this.pSube = this.subeler[0].Sube_rowid;
            else if (!this.pSube) this.pSube = this.guidSube();
          }
        })
        .catch((err) => console.error(err));
    },
    guidSube() {
      const g = (this.varsayilanSubeGuid || "").toLowerCase();
      const s = g && this.subeler.find((x) => String(x.SubeGuid || "").toLowerCase() === g);
      return s ? s.Sube_rowid : null;
    },
    kapat(v) {
      if (v === false || v === undefined || v === null) this.$emit("update:visible", false);
    },
    kontrol() {
      this.Hata.Isim = (this.Isim || "").trim() ? "" : "İsim girin";
      if (!this.CepTelefon) this.Hata.CepTelefon = "Cep telefonu girin";
      else if (!this.$telefonGecerli(this.CepTelefon)) this.Hata.CepTelefon = "Geçerli bir telefon numarası girin";
      else this.Hata.CepTelefon = "";
      if (!this.EPosta) this.Hata.EPosta = "E-Posta adresi girin";
      else if (!this.$mailGecerli(this.EPosta)) this.Hata.EPosta = "Geçerli bir e-posta adresi girin";
      else this.Hata.EPosta = "";
      this.Hata.pSube = this.pSube ? "" : "Şube seçin";
      return Object.values(this.Hata).some(Boolean);
    },
    kaydet() {
      if (this.kaydediliyor || this.kontrol()) return;
      this.kaydediliyor = true;
      this.uyari = "";
      const data = {
        pSube: this.pSube, Isim: this.Isim.trim(), CepTelefon: this.CepTelefon, EPosta: this.EPosta.trim(),
        Aciklama: "", IletisimAdres: "", WebAdres: "",
        BilgilendirmeIzni: false, BilgilendirmeIzinKaynak: null, PazarlamaIzni: false, PazarlamaIzinKaynak: null,
      };
      this.$Servis("POST", "SetMusteri", data)
        .then((res) => {
          if (res.status === 200) {
            this.$toast.add({ severity: "success", summary: "Başarılı", detail: "Müşteri eklendi.", life: 3000 });
            this.$emit("kaydedildi", (res.data && res.data.Musteri_rowid) || 0, { Isim: data.Isim, CepTelefon: data.CepTelefon });
            this.$emit("update:visible", false);
          } else if (res.status === 999) {
            this.uyari = res.data;
          } else {
            this.uyari = "Müşteri kaydedilemedi.";
          }
        })
        .catch(() => { this.uyari = "Bağlantı hatası."; })
        .finally(() => { this.kaydediliyor = false; });
    },
  },
};
</script>
